import React from "react"
import Section from "../Section"
import Navbar from "../Navbar/Navbar"
import Footer from "../Footer"
import styled from "styled-components"

const Format = ({heading, children}) => {
    return (
        <>
          <Navbar />
          <Section sidebar_heading={heading} b_top={true} b_bottom={true} content_pt={3} content_pb={2}>
            <Header>
              {heading}
            </Header>
            <Content>
              {children}
            </Content>
          </Section>
          <Footer />
        </>
    )
}

export default Format

const Header = styled.div`
    // Spacing
  margin: 0;
  padding: var(--spacer-3) 0 0 0;

  // Font
  font-family: var(--headerFont);
  font-style: normal;
  font-weight: bold;
  font-size: var(--font-6);
  line-height: 1.5;
  text-align: center;
  text-transform: uppercase;

  // Color
  color: var(--textRed);


  // Positioning
  position: relative;
  bottom: 2px;
`
const Content = styled.div`
  // Spacing
  margin: var(--spacer-6) 0;
  padding: var(--spacer-2) 0 var(--spacer-1) 0;

  // Font
  font-family: var(--bodyFont);
  font-style: normal;
  font-weight: normal;
  font-size: var(--font-3);
  line-height: 1.5;
  text-align: justify;
`
